module.exports = __webpack_public_path__ + "static/img/img (15).19023d0a.jpg";